import styled from 'styled-components';

export const SpacerContainer = styled.div`
    height: ${props => props.Size ? `var(--spacer-size-${props.Size.toLowerCase()})` : 'auto'};
`;